import { useEffect } from 'react';
import api from '../services/api';

export const PRESENCE_PING_MS = 60_000;

function browserTimeZone(): string | undefined {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch {
    return undefined;
  }
}

/**
 * While this tab is visible, tell the API the person is here (a 2-minute key it refreshes). The user-email sweep
 * holds a "your video needs you" email while the key exists, so nobody is emailed about a screen they are looking at.
 * The first ping of a page load also carries the browser's time zone, so emails keep to the person's hours.
 */
export function usePresence(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return;
    let tzSent = false;
    const ping = () => {
      if (document.visibilityState !== 'visible') return;
      const tz = tzSent ? undefined : browserTimeZone();
      tzSent = true;
      api.post('/presence', tz ? { tz } : undefined).catch(() => {});
    };
    ping();
    const timer = setInterval(ping, PRESENCE_PING_MS);
    document.addEventListener('visibilitychange', ping);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', ping);
    };
  }, [enabled]);
}
